export abstract class ActionRuleChecker {
    public abstract isActionPermitted (targetItem: any): boolean;
}